import { render, staticRenderFns } from "./SalesOrderViewGlobal.vue?vue&type=template&id=28875fa0"
import script from "./SalesOrderViewGlobal.vue?vue&type=script&lang=js"
export * from "./SalesOrderViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports